import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getBlogRequest = () => ({ type: 'GET_BLOG_REQUEST' })
export const getBlogSuccess = (data) => ({ type: 'GET_BLOG_SUCCESS', data })
export const getBlogFailure = (error) => ({ type: 'GET_BLOG_FAILURE', error })

export const addBlogRequest = () => ({ type: 'ADD_BLOG_REQUEST' })
export const addBlogSuccess = () => ({ type: 'ADD_BLOG_SUCCESS' })
export const addBlogFailure = (error) => ({ type: 'ADD_BLOG_FAILURE', error })

export const updateBlogRequest = () => ({ type: 'UPDATE_BLOG_REQUEST' })
export const updateBlogSuccess = () => ({ type: 'UPDATE_BLOG_SUCCESS' })
export const updateBlogFailure = (error) => ({ type: 'UPDATE_BLOG_FAILURE', error })

export const deleteBlogRequest = () => ({ type: 'DELETE_BLOG_REQUEST' })
export const deleteBlogSuccess = () => ({ type: 'DELETE_BLOG_SUCCESS' })
export const deleteBlogFailure = (error) => ({ type: 'DELETE_BLOG_FAILURE', error })

export const getBlogs = () => {
  return (dispatch) => {
    dispatch(getBlogRequest())
    fetch(URL.BASE_URL + URL.END_POINT.blog, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getBlogSuccess(data))
      })
      .catch((error) => {
        dispatch(getBlogFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const addBlog = (newBlog) => {
  return (dispatch) => {
    dispatch(addBlogRequest())
    fetch(URL.BASE_URL + URL.END_POINT.blog, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(newBlog),
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(addBlogSuccess())
        toast.success('Blog added successfully')
        dispatch(getBlogs())
      })
      .catch((error) => {
        dispatch(addBlogFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const updateBlog = (id, updatedBlog) => {
  return (dispatch) => {
    dispatch(updateBlogRequest())
    fetch(URL.BASE_URL + URL.END_POINT.blog + '?id=' + id, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: updatedBlog,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(updateBlogSuccess())
        toast.success('Blog updated successfully')
        dispatch(getBlogs())
      })
      .catch((error) => {
        dispatch(updateBlogFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const deleteBlog = (id) => {
  return (dispatch) => {
    dispatch(deleteBlogRequest())
    fetch(URL.BASE_URL + URL.END_POINT.blog + '?id=' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(deleteBlogSuccess())
        toast.success('Blog deleted successfully')
        dispatch(getBlogs())
      })
      .catch((error) => {
        dispatch(deleteBlogFailure(error.message))
        toast.error(error.message)
      })
  }
}

const initialState = {
  blogs: [],
  loading: false,
  error: null,
}

export const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_BLOG_REQUEST':
    case 'ADD_BLOG_REQUEST':
    case 'UPDATE_BLOG_REQUEST':
    case 'DELETE_BLOG_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_BLOG_SUCCESS':
      return { ...state, blogs: action.data.blogs, loading: false, error: null }
    case 'ADD_BLOG_SUCCESS':
    case 'UPDATE_BLOG_SUCCESS':
    case 'DELETE_BLOG_SUCCESS':
      return { ...state, loading: false, error: null }
    case 'GET_BLOG_FAILURE':
    case 'ADD_BLOG_FAILURE':
    case 'UPDATE_BLOG_FAILURE':
    case 'DELETE_BLOG_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
